/**
 * 模型中心 — 展示 AI 模型状态和使用额度
 * 使用产品语言，不暴露技术名称
 */

import React from 'react';

export default function ModelCenterPage() {
  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h1 style={styles.title}>🧠 模型中心</h1>
        <p style={styles.subtitle}>查看 AI 能力状态、偏好设置和使用额度</p>
      </div>

      {/* Current Status */}
      <div style={styles.statusCard}>
        <div style={styles.statusRow}>
          <span style={styles.statusEmoji}>✅</span>
          <div>
            <span style={styles.statusTitle}>所有 AI 模型运行正常</span>
            <span style={styles.statusDesc}>平均响应时间 1.2s · 可用率 99.8%</span>
          </div>
        </div>
        <div style={styles.statusMetrics}>
          <div style={styles.statusMetric}>
            <span style={styles.statusVal}>1.2s</span>
            <span style={styles.statusLbl}>平均延迟</span>
          </div>
          <div style={styles.statusMetric}>
            <span style={styles.statusVal}>99.8%</span>
            <span style={styles.statusLbl}>可用率</span>
          </div>
          <div style={styles.statusMetric}>
            <span style={styles.statusVal}>847</span>
            <span style={styles.statusLbl}>今日调用</span>
          </div>
        </div>
      </div>

      {/* Usage */}
      <div>
        <h2 style={styles.sectionTitle}>使用额度</h2>
        <div style={styles.usageGrid}>
          <div style={styles.usageCard}>
            <span style={styles.usageLabel}>Token 用量（本月）</span>
            <div style={styles.usageBarWrap}>
              <div style={{ ...styles.usageBar, width: '45%', background: '#6366f1' }} />
            </div>
            <span style={styles.usageText}>4.5M / 10M Tokens</span>
          </div>
          <div style={styles.usageCard}>
            <span style={styles.usageLabel}>请求次数（今日）</span>
            <div style={styles.usageBarWrap}>
              <div style={{ ...styles.usageBar, width: '28%', background: '#34d399' }} />
            </div>
            <span style={styles.usageText}>280 / 1,000 次</span>
          </div>
          <div style={styles.usageCard}>
            <span style={styles.usageLabel}>API 费用（本月）</span>
            <div style={styles.usageBarWrap}>
              <div style={{ ...styles.usageBar, width: '15%', background: '#fbbf24' }} />
            </div>
            <span style={styles.usageText}>$12.50 / $100.00</span>
          </div>
        </div>
      </div>

      {/* Performance */}
      <div>
        <h2 style={styles.sectionTitle}>性能统计</h2>
        <div style={styles.perfGrid}>
          <div style={styles.perfCard}>
            <span style={styles.perfVal}>3.2s</span>
            <span style={styles.perfLbl}>平均执行耗时</span>
          </div>
          <div style={styles.perfCard}>
            <span style={styles.perfVal}>98.5%</span>
            <span style={styles.perfLbl}>执行成功率</span>
          </div>
          <div style={styles.perfCard}>
            <span style={styles.perfVal}>42</span>
            <span style={styles.perfLbl}>支持工具调用</span>
          </div>
          <div style={styles.perfCard}>
            <span style={styles.perfVal}>6</span>
            <span style={styles.perfLbl}>API 渠道</span>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: { maxWidth: 900, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 24 },
  header: {},
  title: { fontSize: 22, fontWeight: 700, margin: 0 },
  subtitle: { fontSize: 12, color: '#64748b', margin: '4px 0 0' },
  statusCard: {
    padding: 18, borderRadius: 12, border: '1px solid rgba(52,211,153,0.15)',
    background: 'rgba(52,211,153,0.04)',
  },
  statusRow: { display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 },
  statusEmoji: { fontSize: 20 },
  statusTitle: { display: 'block', fontSize: 14, fontWeight: 600, color: '#34d399' },
  statusDesc: { display: 'block', fontSize: 11, color: '#64748b' },
  statusMetrics: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 },
  statusMetric: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 },
  statusVal: { fontSize: 16, fontWeight: 700 },
  statusLbl: { fontSize: 10, color: '#64748b' },
  sectionTitle: { fontSize: 15, fontWeight: 600, margin: '0 0 10px' },
  usageGrid: { display: 'flex', flexDirection: 'column', gap: 10 },
  usageCard: { padding: '14px 16px', borderRadius: 10, background: 'rgba(255,255,255,0.025)', border: '1px solid rgba(255,255,255,0.06)' },
  usageLabel: { display: 'block', fontSize: 12, color: '#94a3b8', marginBottom: 6 },
  usageBarWrap: { height: 6, borderRadius: 3, background: 'rgba(255,255,255,0.05)', overflow: 'hidden', marginBottom: 4 },
  usageBar: { height: '100%', borderRadius: 3 },
  usageText: { fontSize: 10, color: '#64748b', fontFamily: 'monospace' },
  perfGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10 },
  perfCard: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, padding: '14px 10px', borderRadius: 10, background: 'rgba(255,255,255,0.025)', border: '1px solid rgba(255,255,255,0.06)' },
  perfVal: { fontSize: 18, fontWeight: 700 },
  perfLbl: { fontSize: 10, color: '#64748b', textAlign: 'center' },
};
